module.exports = __webpack_public_path__ + "static/2front-about-company-mission-1-a28c12b8216511ac1dd31ae571efcfdf.png";